import {
  API_STATES
} from '@/helpers'
  
const state = {
  storesGetState   : API_STATES.NOT_REQUESTED,
  storesGetError   : null,
  storeDeleteState : API_STATES.NOT_REQUESTED,
  storeDeleteError : null,
  stores           : []
}

export default state
  